import { Instagram, MapPin, Phone } from "lucide-react";
import LacBadge from "./LacBadge";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <LacBadge size={90} />
          <div className="mt-4 font-display font-black text-xl tracking-tight text-chrome">
            LONDON AUTOMOTIVE CUSTOMS
          </div>
          <p className="text-zinc-400 mt-3 max-w-sm font-body text-sm leading-relaxed">
            Ambient lighting specialists. Crafted in London. Drive different.
          </p>
        </div>

        <div>
          <div className="text-xs tracking-[0.3em] text-zinc-500 mb-4">FOLLOW</div>
          <div className="flex flex-col gap-3">
            <a
              data-testid="footer-tiktok"
              href="https://www.tiktok.com/@lac.ltd"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-zinc-300 hover:text-[#D946EF] transition-colors group"
            >
              <span className="w-9 h-9 rounded-sm border border-white/10 flex items-center justify-center group-hover:border-[#D946EF]/60 transition">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.7 20.1a6.34 6.34 0 0 0 10.86-4.43V8.69a8.26 8.26 0 0 0 4.83 1.55v-3.4a4.85 4.85 0 0 1-1.8-.15Z" />
                </svg>
              </span>
              <span className="font-medium">@lac.ltd <span className="text-zinc-500 text-xs">· TikTok · 9K+</span></span>
            </a>
            <a
              data-testid="footer-instagram"
              href="https://www.instagram.com/lac.ltd"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-zinc-300 hover:text-[#FF2D87] transition-colors group"
            >
              <span className="w-9 h-9 rounded-sm border border-white/10 flex items-center justify-center group-hover:border-[#FF2D87]/60 transition">
                <Instagram className="w-4 h-4" />
              </span>
              <span className="font-medium">@lac.ltd <span className="text-zinc-500 text-xs">· Instagram</span></span>
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs tracking-[0.3em] text-zinc-500 mb-4">VISIT · CALL</div>
          <p className="text-zinc-300 font-body text-sm flex items-center gap-2">
            <MapPin className="w-4 h-4 text-[#D946EF]" /> Unit 15, Rainham, RM13 8HZ
          </p>
          <a
            href="tel:+447538963090"
            data-testid="footer-phone"
            className="mt-2 text-zinc-300 font-body text-sm flex items-center gap-2 hover:text-[#FF2D87] transition"
          >
            <Phone className="w-4 h-4 text-[#FF2D87]" /> 07538 963090
          </a>
          <a
            href="https://wa.me/447538963090"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="mt-2 text-zinc-300 font-body text-sm flex items-center gap-2 hover:text-[#25D366] transition"
          >
            <svg viewBox="0 0 32 32" className="w-4 h-4 text-[#25D366]" fill="currentColor"><path d="M19.11 17.21c-.27-.13-1.59-.78-1.83-.87-.25-.09-.43-.13-.6.13-.18.27-.69.87-.84 1.04-.16.18-.31.2-.57.07-.27-.14-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.49-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.46.09-.18.04-.34-.02-.48-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.46h-.51c-.18 0-.46.07-.7.34-.24.27-.92.9-.92 2.19s.94 2.55 1.07 2.72c.13.18 1.85 2.83 4.49 3.97.63.27 1.12.43 1.5.55.63.2 1.2.17 1.65.1.5-.07 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.24-.18-.51-.31zM16.03 4C9.4 4 4 9.4 4 16.03c0 2.13.56 4.21 1.62 6.04L4 28l6.07-1.59A12.03 12.03 0 0 0 16.03 28C22.66 28 28 22.66 28 16.03 28 9.4 22.66 4 16.03 4z"/></svg>
            WhatsApp us
          </a>
          <div className="mt-5 pt-4 border-t border-white/5">
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 mb-2">HOURS</div>
            <p className="text-zinc-400 font-body text-xs">Mon – Sat · 09:00 – 18:00</p>
            <p className="text-zinc-500 font-body text-xs">Sunday · Closed</p>
          </div>
          <a href="/admin/login" data-testid="footer-admin-link" className="block mt-6 text-xs text-zinc-600 hover:text-zinc-400 transition">Admin Portal →</a>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-zinc-600 font-body flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <span>© {new Date().getFullYear()} London Automotive Customs Ltd. All rights reserved.</span>
        <a href="/terms" data-testid="footer-terms-link" className="hover:text-zinc-400 transition">
          Terms &amp; Conditions
        </a>
      </div>
    </footer>
  );
}
